import { defineAsyncComponent } from 'vue';

export { default as EliHeadWithShadow } from './components/EliHeadWithShadow.vue';
export type { EliContextData } from './types';

export const eliMicroFrontends = {
	EliSettings: defineAsyncComponent(
		() => import('./components/EliSettings/EliSettings.vue')
	),
};
